

import clientAPI from "@/api/ClientAPIMixin.js";
import KeyDiverMixin from "@/helpers/Mixins/KeyDiverMixin";
import Vue from "vue";



export const JobSubjobs = {
  namespaced: true,


  state: {
    Machines: [],
  },



  mutations: {
    ADD_MACHINE(state, newmachine) {
      if (state.Machines == null || state.Machines == undefined) {
        state.Machines = [];
      }
      state.Machines.unshift(newmachine);
    },
    ADD_MACHINES(state, newmachines) {
      if (state.Machines == null || state.Machines == undefined) {
        state.Machines = [];
      }
      //console.log("ADD_MACHINES", newmachines);
      state.Machines.unshift(...newmachines);
      //console.log("state.Machines", state.Machines);
    },

    CLEAR_MACHINE(state) {
      state.Machines = null;
    },

    SET_PREVIEW_MACHINE(state, newmachine) {
      state.PreviewMachine = newmachine;
    },

    SET_MACHINE_DETAIL(state, update) {
      var index = state.Machines.findIndex(x => x.Id === update.id);
      if (index > -1) {
        var editmachine = state.Machines[index];
        var keyObjectPair = KeyDiverMixin.methods.getValueFromKeychainNotLastKey(editmachine, update.key, false)
        Vue.set(keyObjectPair.object, keyObjectPair.key, update.value);
      }
      else {
        console.error('could not find/update subjob ', update.id)
      }
    },

    REPLACE_MACHINE(state, newsubjob) {
      if (state.Machines == null) {
        state.Machines = []; //initializer new list
      }

      var index = -1
      if (newsubjob.PreNewId) {
        index = state.Machines.findIndex(x => x.Id === newsubjob.PreNewId); //to replace frontend in-creation-stage child jobs
        newsubjob.PreNewId = null;
      }
      else {
        index = state.Machines.findIndex(x => x.Id === newsubjob.Id);
      }

      if (index > -1) {
        Vue.set(state.Machines, index, newsubjob)
      }
      else {
        state.Machines.unshift(newsubjob)
      }
    },

    REMOVE_MACHINE(state, machineid) {
      state.Machines = state.Machines.filter(x => x.Machine.Id !== machineid);
    },

    SET_MACHINES(state, newmachines) {
      state.Machines = newmachines;
    },
  },



  actions: {
    addSubjobs({ commit }, subjobs) {
      commit("ADD_MACHINES", subjobs);
    },
    addSubjob({ commit }, subjob) {
      commit("ADD_MACHINE", subjob);
    },

    async getMachineAndAddSubjob({ state, dispatch }, machineid) {
      // disallow multiple entries of same machine
      if (state.Machines?.find(e => e.Machine.Id == machineid)) return;
      var machine = await clientAPI.methods.getMachineById(machineid)
        .then((response) => {
          //console.log("machine", response);
          return response;
        })
        .catch((e) => console.error(e));
      dispatch("addMachineAsSubjob", machine);
    },

    addMachineAsSubjob({ commit, rootGetters, rootState }, machine) {
      const parentId = (rootGetters['JobHub/JobDetails'])?.Id;
      const parentBasedDefaultNoInvoice = (rootGetters['JobHub/JobDetails'])?.NoInvoice;
      const parentBasedDefaultJobType = (rootGetters['JobHub/JobDetails'])?.JobTypeId;
      const defaultJobCategoryId = (rootState.GlobalSettings?.DefaultJobCategoryId)

      const newSubjob = {
        New: true,
        Id: new Date().getTime(),
        ParentId: parentId,
        CustomerComment: null,
        SupplierFailureCodeId: null,
        NoInvoice: parentBasedDefaultNoInvoice,
        JobTypeId: parentBasedDefaultJobType,
        Machine: Object.assign({}, machine),
      };
      if (defaultJobCategoryId) {
        newSubjob.JobCategoryId = defaultJobCategoryId;
      }
      commit("ADD_MACHINE", newSubjob);
    },

    async getSubjob({ dispatch }, id) {
      clientAPI.methods.getSubjob(id)
        .then((response) => {

          dispatch("addSubjob", response);
        });
    },

    async getAndReplaceSubjob({ dispatch }, id) {
      clientAPI.methods.getSubjob(id)
        .then((response) => {

          dispatch("replaceSubjob", response);
        });
    },

    setSubjobDetail({ commit }, update) {
      commit("SET_MACHINE_DETAIL", update);
    },

    replaceSubjob({ commit }, subjob) {
      commit("REPLACE_MACHINE", subjob);
    },

    async removeSubjob({ commit }, ids) {
      //if new just remove from list
      if (ids.jobId === -1) {
        commit("REMOVE_MACHINE", ids.machineId);
      }
      //if old remove from database and list
      else {
        clientAPI.methods.removeSubjob(ids.jobId)
          .then(() => {
            commit("REMOVE_MACHINE", ids.machineId);
          });
      }
    },

    clearSubjobs({ commit }, val) {
      commit("SET_MACHINES", val);
    },
  },



  getters: {
    Subjobs: state => {
      return state.Machines;
    },

    // Returns the first available machine delivery address dto from the machines list
    MachineDeliveryAddressCandidate: state => {
      const machines = state.Machines;
      if (!machines || !machines.length) {
        return null;
      }
      const firstWithAddr = machines.map(sj => sj && sj.Machine)
        .find(m => m && (m.CustomerDeliveryAddress != null));
      return firstWithAddr?.CustomerDeliveryAddress || null;
    },

    ChildJob: (state) => (jobId) => {
      return state
        .Machines
        .find(cj => cj.Id === jobId)
    },
  },

};
